namespace Matrix.Data {
    export namespace TestService {
        export const baseUrl = 'Data/Test';

        export declare function Create(request: Serenity.SaveRequest<TestRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<TestRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<TestRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<TestRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Run(request: Data.Repositories.TestRunRequest, onSuccess?: (response: Data.Repositories.TestRunResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Data/Test/Create",
            Update = "Data/Test/Update",
            Delete = "Data/Test/Delete",
            Retrieve = "Data/Test/Retrieve",
            List = "Data/Test/List",
            Run = "Data/Test/Run"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'Run'
        ].forEach(x => {
            (<any>TestService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
